import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import { DeliverySchedule } from './../../../app/services/api/orderManagementClient';
import isSameOrAfter from 'dayjs/plugin/isSameOrAfter';
import isSameOrBefore from 'dayjs/plugin/isSameOrBefore';
dayjs.extend(utc);
/**
 * Timezone-safe date matching
 * Handles the issue where backend dates like "2025-07-02T00:00:00" need to be matched
 * against OrderForm delivery dates in formats like "DD-MM-YYYY" or "MM/DD/YYYY"
 */
export const isSameDayOrderForm = (backendDateString: Date, orderFormDeliveryDate: string): boolean => {
  const backendDate = dayjs(backendDateString);

  let orderFormDate: dayjs.Dayjs;

  if (orderFormDeliveryDate.includes('/')) {
    // MM/DD/YYYY format (Rustan Philippines)
    orderFormDate = dayjs(orderFormDeliveryDate, 'MM/DD/YYYY');
  } else {
    // DD-MM-YYYY format (default with dash separator)
    orderFormDate = dayjs(orderFormDeliveryDate, 'DD-MM-YYYY');
  }

  // Compare only the date, not time
  return backendDate.isSame(orderFormDate, 'day');
};

dayjs.extend(isSameOrAfter);
dayjs.extend(isSameOrBefore);

export const getNext7DaysDeliverySchedules = (deliverySchedules: DeliverySchedule[]) => {
  const today = dayjs();
  const sevenDaysFromNow = today.add(7, 'day');
  return deliverySchedules.filter(schedule => {
    const delivery = dayjs(schedule.cutOffDate, 'DD-MM-YYYY');
    return delivery.isSameOrAfter(today, 'day') && delivery.isSameOrBefore(sevenDaysFromNow, 'day');
  });
};